import { render, staticRenderFns } from "./SignVideo.vue?vue&type=template&id=2d1c52d6&scoped=true"
import script from "./SignVideo.vue?vue&type=script&lang=js"
export * from "./SignVideo.vue?vue&type=script&lang=js"
import style0 from "./SignVideo.vue?vue&type=style&index=0&id=2d1c52d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c52d6",
  null
  
)

export default component.exports